export default __webpack_public_path__ + "static/optional_steps_ebike-541688b182f731f43ec366729219338f.png";